import React from 'react'

const title = ({date}) => {
  return (
    <h1 className="text-center mb-4">{date}</h1>
  )
}

export default title